import { view } from "@risingstack/react-easy-state";
import { cn } from "@tine/designsystem-utils";
import type { PropsWithChildren } from "react";

const Quote = ({ children }: PropsWithChildren) => {
   const quoteComponentStyle = "tw-my-16 tw-flex tw-flex-col tw-items-center tw-gap-4 md:tw-gap-5";
   const doubleQuotationMarkStyle = "tw-w-self tw-h-12 tw-text-8xl md:tw-text-9xl tw-font-bold tw-font-['InaiMathi']";
   const quoteStyle =
      "tw-text-center tw-text-2xl md:tw-text-2xl tw-font-semibold [&_p]:tw-mb-0 [&>div]:tw-mx-0 [&>div]:tw-w-full [&>div]:tw-max-w-xl";

   return (
      <blockquote className={cn(quoteComponentStyle, quoteStyle)}>
         <span className={doubleQuotationMarkStyle}>“</span>
         {children}
      </blockquote>
   );
};

export default view(Quote);
